export function parseGuid(inputValue: string): string {
  let trimValue: string = inputValue;
  trimValue = trimValue.replace(/\s+/g, '');
  trimValue = trimValue.replace(/\-/g, '');
  trimValue = trimValue.replace(/\{/g, '');
  trimValue = trimValue.replace(/\}/g, '');
  let result = '';
  for (let i = 0; i < trimValue.length; i++) {
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      result += '-';
    }
    result += trimValue[i];
  }

  return result;
}
